import React from 'react';
import styled from 'styled-components';

const ErrorMessageWrapper = styled.div`
  color: rgba(217, 54, 56, 1);
  font-style: italic;
  font-size: small;
`;

interface IErrorMessage {
  children: React.ReactNode | string;
}

const ErrorMessage: React.FC<IErrorMessage> = ({ children }) => {
  return <ErrorMessageWrapper>{children}</ErrorMessageWrapper>;
};

export default ErrorMessage;
